import { memo } from 'react';
import { connect } from 'react-redux';
import { flow } from 'lodash/fp';
import withLayout from 'src/hoc/withLayout';
import { DEFAULT_LAYOUT } from 'src/constants/common';
import selectors from './selectors';
import ProductPage from './ProductPage';

export default flow(
  memo,
  withLayout(DEFAULT_LAYOUT),
  connect(
    selectors,
    null,
  ),
)(ProductPage);
